import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import url from 'url';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { libraryShape } from '@bibliocommons/bc-prop-types';
import BcReactComponent from '@bibliocommons/base-bc-react-component';
import { currentLibrarySelector, getLibraryLinkedData } from 'app/selectors/LibrarySelector';
import { getAppConfig } from 'app/selectors/AppSelector';
import DocumentHead from './DocumentHead';

/** @extends React.Component */
export class DocumentHeadContainer extends BcReactComponent {
  render() {
    return <DocumentHead {...this.props} />;
  }
}

DocumentHeadContainer.propTypes = {
  // ownProps
  pageTitle: PropTypes.string,
  description: PropTypes.string,
  imageUrl: PropTypes.string,
  linkedData: ImmutablePropTypes.map,
  noIndex: PropTypes.bool,

  // Redux props
  appVersion: PropTypes.string,
  pageUrl: PropTypes.string.isRequired,
  currentLibrary: libraryShape.isRequired,
  libraryLinkedData: ImmutablePropTypes.map.isRequired
};

const mapStateToProps = state => {
  const appConfig = getAppConfig(state);
  const baseURL = appConfig.get('baseURL');
  const currentURL = appConfig.get('currentURL');

  return {
    currentLibrary: currentLibrarySelector(state),
    libraryLinkedData: getLibraryLinkedData(state),
    appVersion: appConfig.get('appVersion'),
    pageUrl: baseURL && currentURL && url.resolve(baseURL, currentURL)
  };
};

export default connect(mapStateToProps)(DocumentHeadContainer);
